// extracted by mini-css-extract-plugin
module.exports = {"listItem":"style_listItem__28HI2","list":"style_list__14BPf","languageText":"style_languageText__3DETj","langContainer":"style_langContainer__2b2Tt"};